// extracted by mini-css-extract-plugin
export var category = "_gr-9";
export var categoryHeader = "_gr-e";
export var container = "_gr-0";
export var group = "_gr-a";
export var groupItems = "_gr-f";
export var groupSeparator = "_gr-j";
export var loading = "_gr-1";
export var noResults = "_gr-3";
export var placeholder = "_gr-2";
export var resultContent = "_gr-5";
export var resultIcon = "_gr-c";
export var resultItem = "_gr-g";
export var resultMeta = "_gr-8";
export var resultSubtitle = "_gr-7";
export var resultSuffix = "_gr-i";
export var resultTitle = "_gr-6";
export var resultsList = "_gr-4";
export var searchGroup = "_gr-d";
export var selected = "_gr-h";
export var subgroup = "_gr-b";